// Polyfills
import 'babel-polyfill';
import 'whatwg-fetch';

import objectFitImages from 'object-fit-images';

// Dependencies
import Header from 'layouts/chrome/header';

import PageHome from 'templates/page-home';
import PageAbout from 'templates/page-about';
import PageCases from 'templates/page-cases';
import PageContact from 'templates/page-contact';
import ArchivePost from 'templates/archive-post';

// Constants
const TEMPLATES = {
  'page-home'   : PageHome,
  'page-about'  : PageAbout,
  'page-cases'  : PageCases,
  'page-contact': PageContact,
  'archive-post': ArchivePost,
};


class Manager {
  /**
   * Constructor: Manager Constructor.
   */
  constructor() {
    // Elements
    this._root = document.querySelector('[layout]');
    
    // Attributes
    this._tplClass = null;
    this._tplName  = this._root.getAttribute('layout');

    if (this._tplName) {
      if (TEMPLATES[this._tplName]) {
        this._tplClass = new TEMPLATES[this._tplName]();
      }
    }

    // Static
    this.Header = new Header();

    // Polyfills
    this.polyfills();

    // Events
    this._resize = this.resize.bind(this);
    this._update = this.update.bind(this);

    // Resize
    window.addEventListener('resize', this._resize);
    
    // Update
    window.requestAnimationFrame(this._update);
  }


  /**
   * Polyfills: Applu polyfills.
   */
  polyfills() {
    // Object Fit polyfill for images.
    objectFitImages('[data-object-fit]');
  }


  /**
   * Resize: Trigger `resize` method of the class.
   */
  resize() {
    if (this.Header) {
      if (this.Header.resize) {
        this.Header.resize();
      }
    }

    if (this._tplClass) {
      if (this._tplClass.resize) {
        this._tplClass.resize();
      }
    }
  }


  /**
   * Update: Trigger `update` method of the class at 60FPS.
   */
  update() {
    if (this.Header) {
      if (this.Header.update) {
        this.Header.update();
      }
    }

    if (this._tplClass) {
      if (this._tplClass.update) {
        this._tplClass.update();
      }
    }

    // Loop
    window.requestAnimationFrame(this._update);
  }
}

export default Manager;


// WEBPACK FOOTER //
// ./src/js/manager.js